(function() { window.GUID_101a68a3_13c5_4b25_9ef8_fee49a0ecf54 = { getGuid: function() { return "101a68a3-13c5-4b25-9ef8-fee49a0ecf54"; } }; })();
//module CS.Controls {
//    export class CachedPageVerificator extends ControlBase {
//        public OnDispose() {
//            this.$Control.remove();
//        }
//        public OnBindEvents( ) {
//        }
//        private elementtohidewhileloading: JQuery;
//        private $control: JQuery;
//        private controlId: string;
//        public get ControlId(): string {
//            return this.controlId;
//        }
//        public get $Control(): JQuery {
//            return this.$control;
//        }
//        protected OnControlInstantiation(params: any[]) {
//            this.controlId = params[0];
//            this.$control = $('#' + params[0]);//contient le Id
//            let me = this;
//            if (me.$Control.length > 0) {
//                me.elementtohidewhileloading = $(me.$Control.data('elementtohidewhileloading'));
//                let tick = me.$Control.data('tick');
//                let data = {
//                    tick: tick
//                };
//                CS.Ajax.Get(Url.CSUrl("checkifneedrefresh"), data, function (response) {
//                    if (response.refresh == true) {
//                        var href = window.location.href;
//                        var closingTag = "____";
//                        var indexOfForceReload = href.indexOf(closingTag);
//                        var indexOfEndForceReload = href.lastIndexOf(closingTag) + (closingTag).length;
//                        if (indexOfForceReload > -1) {
//                            var forceReloadPart = href.substr(indexOfForceReload, indexOfEndForceReload - indexOfForceReload);
//                            href = href.replace(forceReloadPart, '');
//                        }
//                        let hrefEnd = href.length - 1;
//                        let indexOfQuestMark = href.indexOf('?');
//                        let indexOfAmpersand = href.indexOf('&');
//                        if (indexOfQuestMark == -1) {
//                            href += "?";
//                        }
//                        else if (indexOfQuestMark != hrefEnd && indexOfAmpersand != hrefEnd) {
//                            href += "&";
//                        }
//                        href += closingTag + response.tick + closingTag;
//                        console.info("cache.replacing url: " + window.location.href);
//                        console.info("cache.replacing newurl: " + href);
//                        window.location.replace(href);
//                    }
//                    else {
//                        if (!me.elementtohidewhileloading.data('force-hidden') == true) {
//                            me.elementtohidewhileloading.show();
//                        }
//                    }
//                });
//            }
//        }
//    }
//}

//# sourceMappingURL=CachedPageVerificator.js.map
